var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("validationService", function () {
    var regularExpressions = {
        alphanumeric: /^[a-zA-Z0-9]+$/,
        creditCard: {
            amex: new RegExp("^3[47][0-9]{13}$"),
            diners: new RegExp("^3(?:0[0-5]|[68][0-9])[0-9]{11}$"),
            discover: new RegExp("^6(?:011|5[0-9]{2})[0-9]{12}$"),
            jcb: new RegExp("^(?:2131|1800|35\\d{3})\\d{11}$"),
            master: new RegExp("^5[1-5][0-9]{14}$"),
            visa: new RegExp("^4[0-9]{12}(?:[0-9]{3})?$"),
        },
        decimalNumberUnsigned: /^\d*\.?\d+$/,
        email: /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/,
        hexColorCode: /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/,
        name: /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/,
        numbersWithoutDecimal: /^([1-9][0-9]*)$/,
        password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{12,20}$/,
        phone: /^\+?(\d{1,4})?\s?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/,
        timeTwelveHourFormat: /^(0?[1-9]|1[012])(:[0-5]\d) [APap][mM]$/,
        timeHHMM: /^([0-9][0-9]):([0-5][0-9])$/,
        sqlInjection:
            /^(?:[\w \!\#\$\%\&\'\*\+\-\/\\?\^\`\{\|\}\~]+\.)*[\w \!\#\$\%\&\'\*\+\-\/\\?\^\`\{\|\}\~\@\:\;\"\.\,\[\]]+$/,
        postalCode_US: /(^\d{5}$)|(^\d{5}-\d{4}$)/,
        feedbackComments: /^[a-zA-Z0-9\s,.'&]*$/,
    };

    return {
        getRegularExpressions: function () {
            return regularExpressions;
        },
    };
});
